import React, { useState } from "react";


import {
  FaHospital,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function HealthcareHospitalsPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Clinical Support & Diagnostics",
      points: [
        "Diagnostic Support Agent",
        "Treatment Recommendation Agent",
        "Medical Imaging Interpretation Agent",
        "Adverse Event Detection Agent",
        "Biomarker Prediction Agent",
      ],
    },

    {
      title: "Clinical Workflow & Operations",
      points: [
        "Real-Time Clinical Decision Support Agent",
        "Medication Safety Agent",
        "Treatment Plan Adaptation Agent",
        "Referral Prioritization Agent",
        "Virtual Nurse Agent",
      ],
    },

    {
      title: "Administrative & Revenue Cycle",
      points: [
        "Appointment Scheduling Agent",
        "Billing & Coding Agent",
        "Insurance Verification Agent",
        "Claims Processing Agent",
        "Prior Authorization Agent",
      ],
    },

    {
      title: "Research, R&D & Life Sciences",
      points: [
        "Literature Summarization Agent",
        "Trial Design Recommendation Agent",
        "Patient Recruitment Agent for Trials",
        "Real-World Evidence Agent",
        "Adverse Events Monitoring Agent",
      ],
    },

    {
      title: "Patient Engagement & Wellness",
      points: [
        "Virtual Health Assistant Agent",
        "Medication Adherence & Refill Agent",
        "Chronic Disease Coaching Agent",
        "Lifestyle Intervention Agent",
        "Mental Health Support & CBT Chat Agent",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .healthcare-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .healthcare-hero {
          background: #173b8f;
          width: 100%;
        }

        .healthcare-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .healthcare-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .healthcare-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .healthcare-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .healthcare-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .healthcare-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .healthcare-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .healthcare-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .healthcare-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .healthcare-card-header.active {
          background: #173b8f;
        }

        .healthcare-card-header.inactive {
          background: #ffffff;
        }

        .healthcare-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .healthcare-card-title.active {
          color: #ffffff;
        }

        .healthcare-card-title.inactive {
          color: #173b8f;
        }

        .healthcare-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .healthcare-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .healthcare-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .healthcare-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .healthcare-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .healthcare-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .healthcare-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .healthcare-hero-inner {
            padding: 32px 0px;
          }

          .healthcare-title {
            font-size: 30px;
          }

          .healthcare-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .healthcare-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .healthcare-icon-box {
            width: 40px;
            height: 40px;
          }

          .healthcare-icon-box svg {
            font-size: 18px;
          }

          .healthcare-title {
            font-size: 26px;
          }

          .healthcare-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .healthcare-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .healthcare-card-header {
            padding: 12px 16px;
          }

          .healthcare-card-title {
            font-size: 15px;
          }

          .healthcare-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .healthcare-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .healthcare-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .healthcare-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .healthcare-icon-box svg {
            font-size: 16px;
          }

          .healthcare-title {
            font-size: 21px;
          }

          .healthcare-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .healthcare-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .healthcare-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .healthcare-card-header {
            padding: 10px 14px;
          }

          .healthcare-card-title {
            font-size: 14px;
          }

          .healthcare-card-content {
            padding: 14px 14px;
          }

          .healthcare-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .healthcare-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .healthcare-point-check svg {
            font-size: 9px;
          }

          .healthcare-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .healthcare-title {
            font-size: 18px;
          }

          .healthcare-card-title {
            font-size: 13px;
          }

          .healthcare-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="healthcare-wrapper">
        {/* HERO SECTION */}
        <div className="healthcare-hero">
          <div className="healthcare-hero-inner">
            <div className="healthcare-hero-top">
              <div className="healthcare-icon-box">
                <FaHospital />
              </div>

              <h1 className="healthcare-title">
                The Healthcare & Hospitals sector
              </h1>
            </div>

            <p className="healthcare-description">
              Healthcare focuses on patient care, diagnostics,
              treatment, and hospital operations. AI agents aid in
              real-time diagnostics, virtual health assistants,
              workflow optimization, medical imaging analysis,
              and patient risk monitoring.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="healthcare-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="healthcare-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`healthcare-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`healthcare-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="healthcare-chevron-active" />
                  ) : (
                    <FaChevronDown className="healthcare-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="healthcare-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="healthcare-point-row">
                        <div className="healthcare-point-check">
                          <FaCheck />
                        </div>

                        <p className="healthcare-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default HealthcareHospitalsPage;
